import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Services from "@/components/sections/Services";
import Industries from "@/components/sections/Industries";
import HiringProcess from "@/components/sections/HiringProcess";
import Breadcrumb from "@/components/Breadcrumb";

export default function ServicesPage() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
    }
  }, [hash]);

  return (
    <>
      <section className="pt-32 pb-16 lg:pt-40 lg:pb-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-primary">Our Services</p>
          <h1 className="mt-3 font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl text-slate-900 leading-[1.05] tracking-tight max-w-4xl mx-auto">
            Recruitment, staffing, payroll & HR — all under one roof
          </h1>
          <p className="mt-6 max-w-2xl mx-auto text-base sm:text-lg text-slate-600 leading-relaxed">
            Five integrated practice areas designed to handle every aspect of your workforce lifecycle.
          </p>
        </div>
      </section>
      <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "Services" }]} />
      <Services detailed />
      <Industries />
      <HiringProcess />
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl">Need a customized solution?</h2>
          <p className="mt-4 text-slate-300">Speak with our HR experts and get a tailored proposal within one business day.</p>
          <Link
            to="/contact"
            data-testid="services-final-cta"
            className="mt-8 inline-flex px-7 py-3.5 rounded-lg bg-white text-slate-900 font-semibold hover:bg-blue-50 transition-colors"
          >
            Request Proposal
          </Link>
        </div>
      </section>
    </>
  );
}
